import {
  Calendar,
  FolderOpen,
  HelpCircle,
  Settings,
  User,
  Users,
} from 'lucide-react'
import type { JSX } from 'react/jsx-runtime'
import { NavLink } from 'react-router-dom'
import { routes } from '@/common/constants/routes'

export const BottomNav = (): JSX.Element => {
  const navItems = [
    { icon: FolderOpen, id: 'cases', label: 'Cases', path: routes.CASES },
    {
      icon: Calendar,
      id: 'calendar',
      label: 'Calendar',
      path: routes.CALENDAR,
    },
    { icon: Users, id: 'clients', label: 'Clients', path: routes.CLIENTS },
    { icon: User, id: 'team', label: 'Team', path: routes.TEAM },
    {
      icon: Settings,
      id: 'settings',
      label: 'Settings',
      path: routes.SETTINGS,
    },
    { icon: HelpCircle, id: 'help', label: 'Help', path: routes.HELP },
  ]

  return (
    <nav
      className="
        fixed inset-x-0 bottom-0 z-10 border-t border-gray-200 bg-white
        md:hidden
        dark:border-gray-700 dark:bg-gray-900
      "
    >
      <div className="grid grid-cols-8 gap-0 px-1 py-2">
        {navItems.map((item) => {
          const Icon = item.icon

          return (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) => {
                return `flex flex-col items-center justify-center py-1 px-1 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-teal-50 dark:bg-teal-900/20 text-teal-600 dark:text-teal-400'
                    : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800'
                }`
              }}
            >
              <Icon className="mb-0.5 size-5" />
              <span className="text-[9px] font-medium">{item.label}</span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
